<div class="eco-hist-flt">
  <!-- Alternadores do design system: app-button tema white + [selected] (navy quando ativo). -->
  <div class="eco-hist-flt__group" role="group" aria-label="Período">
    @for (p of presets; track p.value) {
      <app-button
        [label]="p.label"
        size="small"
        theme="white"
        [noMargin]="true"
        [selected]="preset() === p.value"
        (sendClick)="selectPreset(p.value)" />
    }
    <app-button
      [label]="customLabel()"
      icon="calendar"
      size="small"
      theme="white"
      [noMargin]="true"
      [selected]="preset() === 'custom'"
      [ariaLabel]="'Período livre: ' + customLabel()"
      (sendClick)="toggleCustom()" />
  </div>

  <div class="eco-hist-flt__group" role="group" aria-label="Régua da economia">
    <app-button
      label="Prevista Inicial"
      size="small"
      theme="white"
      [noMargin]="true"
      [selected]="measure() === 'inicial'"
      (sendClick)="setMeasure('inicial')" />
    <app-button
      label="Prevista até Final"
      size="small"
      theme="white"
      [noMargin]="true"
      [selected]="measure() === 'atual'"
      (sendClick)="setMeasure('atual')" />
  </div>

  <app-button
    icon="refresh"
    [text]="true"
    [pureIcon]="true"
    [noMargin]="true"
    [isLoading]="loading()"
    ariaLabel="Atualizar"
    pTooltip="Atualizar"
    tooltipPosition="top"
    (sendClick)="refresh.emit()" />

  @if (showCustom()) {
    <div class="eco-hist-flt__custom">
      <div class="eco-hist-flt__date">
        <app-calendar
          label="De"
          [(ngModel)]="fromDate"
          (ngModelChange)="onCustomDateChange()"></app-calendar>
      </div>
      <div class="eco-hist-flt__date">
        <app-calendar
          label="Até"
          [(ngModel)]="toDate"
          (ngModelChange)="onCustomDateChange()"></app-calendar>
      </div>
    </div>
  }
</div>
